import script from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderComponent.vue?vue&type=style&index=0&id=242bcdcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242bcdcc"]])

export default __exports__